import '../App.css'

export const NewsText = () => {
    return (
        <div className='p-container'>
            <p className='p'>Te mostramos toda la información realizada por la sección sindical de UGT.</p>
        </div>
    )
}